import { ModalContainerProps, ModalContainer } from '@vw-marketing/us-components';
import React from 'react'
import { FeatureAppTrackingManager } from '../../../services/use-tracking-manager';
import { unsetPagemainZindex, disabledScroll } from '../../../utils/general';
import { DealerReview } from '../../../typings/dealer-review';
import { AllReviewsContainer, StyledModalWrapper } from './styles';
import DealerReviewCard from '../../../components/dealer-review-card';
import DealerReviewsPages from '../../../components/dealer-reviews-pages';


interface AllDealerReviewsProps extends ModalContainerProps {
  reviews?: DealerReview;
  trackingManager: FeatureAppTrackingManager;
  hasReviews?: boolean;
}

const AllDealerReviews: React.FC<AllDealerReviewsProps> = (props) => {
  const { onCloseHandler, reviews, active, trackingManager, hasReviews } = props;
  React.useEffect(() => {
    // Avoid the navigation menu overlap issue
    unsetPagemainZindex();
  }, []);

  React.useEffect(() => {
    disabledScroll(active);
    // active && onHandleLayerLoadTrackEvent(trackingManager, reviews)
  }, [active]);

  return (<StyledModalWrapper>
      <ModalContainer
        active={active}
        onCloseHandler={onCloseHandler}
      >
        <AllReviewsContainer>
          <DealerReviewCard
            dealerReview={reviews}
          />{
            hasReviews && <DealerReviewsPages
            reviews={reviews}
            trackingManager={trackingManager}
          />
          }
          
        </AllReviewsContainer>
      </ModalContainer>
    </StyledModalWrapper>
  );
};


export default AllDealerReviews